// Angular + External
import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { Router } from "@angular/router";
// BFX
import { BfxAuthService } from "../bfx-common/services/bfx-auth.service";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Component({
  selector: "bfx-restart-logout",
  templateUrl: "./html/restart-logout.component.html",
  standalone: false,
})
export class RestartLogoutComponent implements OnInit {
  private restartMessage = "Restarting";

  constructor(
    private _authService: BfxAuthService,
    private _router: Router,
  ) {}

  ngOnInit(): void {
    if (this._authService.isAuthenticated()) {
      this._authService.logout();
    }

    let cp: string = this._authService.getSSOContextPath();
    window.location.replace(cp != null ? cp : "/");
  }
}
